module.exports = __webpack_public_path__ + "static/media/table-design.61fc3474.svg";